import { get, put, post, formDataPost } from "helpers/api_helper"
import { normalizeWebsiteBuilderType, WEBSITE_BUILDER_TYPES } from "modules/website-builder/constants/websiteTypes"

const CONFIG_PATH_BY_TYPE = {
  [WEBSITE_BUILDER_TYPES.STOREFRONT]: "website-config",
  [WEBSITE_BUILDER_TYPES.QR]: "qr-website-config",
}

const saWebsiteConfigPath = (tenantId, suffix = "", websiteType = WEBSITE_BUILDER_TYPES.STOREFRONT) => {
  const normalizedType = normalizeWebsiteBuilderType(websiteType)
  const configSegment = CONFIG_PATH_BY_TYPE[normalizedType] || CONFIG_PATH_BY_TYPE[WEBSITE_BUILDER_TYPES.STOREFRONT]
  const base = `superadmin/tenants/${tenantId}/${configSegment}`
  return suffix ? `${base}/${suffix}` : base
}

export const fetchWebsiteBuilderConfig = (tenantId, websiteType = WEBSITE_BUILDER_TYPES.STOREFRONT) =>
  get(saWebsiteConfigPath(tenantId, "", websiteType))

export const fetchWebsiteTemplates = (tenantId, websiteType = WEBSITE_BUILDER_TYPES.STOREFRONT) =>
  get(saWebsiteConfigPath(tenantId, "templates", websiteType))

export const fetchWebThemes = (tenantId, websiteType = WEBSITE_BUILDER_TYPES.STOREFRONT) =>
  get(saWebsiteConfigPath(tenantId, "web-themes", websiteType))

export const saveWebsiteBuilderDraft = (tenantId, config, websiteType = WEBSITE_BUILDER_TYPES.STOREFRONT) =>
  put(saWebsiteConfigPath(tenantId, "draft", websiteType), { config })

export const saveWebsiteThemeBaseline = (tenantId, baseline, websiteType = WEBSITE_BUILDER_TYPES.STOREFRONT) =>
  post(saWebsiteConfigPath(tenantId, "save-theme-baseline", websiteType), { baseline })

export const publishWebsiteBuilderConfig = (tenantId, websiteType = WEBSITE_BUILDER_TYPES.STOREFRONT) =>
  post(saWebsiteConfigPath(tenantId, "publish", websiteType), {})

export const discardWebsiteBuilderDraft = (tenantId, websiteType = WEBSITE_BUILDER_TYPES.STOREFRONT) =>
  post(saWebsiteConfigPath(tenantId, "discard-draft", websiteType), {})

export const uploadWebsiteBuilderAsset = (
  tenantId,
  file,
  purpose = "",
  websiteType = WEBSITE_BUILDER_TYPES.STOREFRONT
) => {
  const data = new FormData()
  data.append("image", file)
  if (purpose) {
    data.append("purpose", purpose)
  }
  return formDataPost(saWebsiteConfigPath(tenantId, "upload", websiteType), data)
}
